import { useContext } from "react"
import { Theme } from "../../../modules/design/Theme"
import { ThemeContext } from "../ThemeContext"

export const useTheme = (): Theme => useContext(ThemeContext)
